<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100" align="left">
        <md-card>
          <md-card-header>
            <h4 class="title">INBOX</h4>
            <hr style="width: 100%; border-bottom: 1px solid green;" />
          </md-card-header>

          <md-card-content style="overflow: auto; height: 75vh;">
            <div
              v-for="(msg, index) in messages"
              :key="index"
              class="alert alert-primary"
              @click="selectMessage(msg.id)"
            >
              <button type="button" aria-hidden="true" class="close">×</button>
              <span style="font-size: .85rem;">{{ msg.MsgDate }}</span>
              <span style="font-size: .7rem;">{{ msg.Subject }}</span>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-70 md-small-size-100" align="left">
        <md-card>
          <md-card-header>
            <h4 class="title">MESSAGE</h4>
            <hr style="width: 100%; border-bottom: 1px solid green;" />
          </md-card-header>
          <md-card-content>
            <md-card>
              <md-card-header>
                <div align="left">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">Date: </span>
                  <span style="font-size: .9rem;">{{ msg.MsgDate }}</span>
                </div>
                <div align="left">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">From: </span>
                  <span style="font-size: .9rem;">{{ msg.Sender }}</span>
                </div>
                <div align="left">
                  <span style="font-size: .8rem; font-weight: 400; margin-right: 5px;">Subject: </span>
                  <span style="font-size: .9rem;">{{ msg.Subject }}</span>
                </div>
                <hr />
              </md-card-header>
              <md-card-content style="overflow: auto; height: 55vh;">
                <span v-html="msg.Body" />
              </md-card-content>
              <md-card-actions />
            </md-card>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      route: "/msg/msgs-in/",
      messages: [],
      message: [],
      msg: {}
    }
  },
  computed: {
    msgSender() {
      if (this.msg) {
        return this.msg.Sender
      } else {
        return ""
      }
    },
    msgSubject() {
      if (this.msg) {
        return this.msg.Subject
      } else {
        return ""
      }
    },
    msgDate() {
      if (this.msg) {
        return this.msg.MsgDate
      } else {
        return ""
      }
    },
    msgBody() {
      if (this.msg) {
        return this.msg.Body
      } else {
        return ""
      }
    }
  },
  created: function() {},
  mounted: function() {
    this.getMessages()
  },
  methods: {
    async getMessages() {
      const url = process.env.VUE_APP_URL + this.route + sessionStorage.getItem("username")
      const config = {
        headers: {
          "Content-Type": "application/json" /*'Access-Control-Allow-Origin': '*', */
        }
      }
      const data = null

      var vm = this
      await window.axios
        .get(url, data, config, { useCache: false })
        .then(r => r.data)
        .then(msgs => {
          this.messages = msgs
        })
    },
    selectMessage(id) {
      this.message = this.messages.filter(m => m.id == id)
      this.msg = this.message[0]
    }
  }
}
</script>
